import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ServiceDesc = ({ options, toggleEdit, onSaveService, showEdit }) => (
  <div className="services-import__list-service-edit">
    {!showEdit && (
      <Button bsSize="xsmall" onClick={toggleEdit}>
        <span className="fas fa-pen mr-4" />
        <span className="ml-4">Edit</span>
      </Button>
    )}
    {showEdit && (
      <Button bsSize="xsmall" onClick={onSaveService}>
        Save
      </Button>
    )}
    <div className="services-import__list-service-edit-icons">
      {options.dripfeed && <span className="icon fas fa-tint" />}
      {options.refill && <span className="icon far fa-sync-alt" />}
      {options.cancel && <span className="icon far fa-ban" />}
    </div>
    {options.max && options.min ? (
      <div className="services-import__list-service-edit-extremum">
        <div className="extremum-item">
          <span className="text-grey">Min:</span>
          <span className="ml-4">{options.min}</span>
        </div>

        <div className="extremum-item">
          <span className="text-grey">Max:</span>
          <span className="ml-4">{options.max}</span>
        </div>
      </div>
    ) : null}
  </div>
);

ServiceDesc.propTypes = {
  options: PropTypes.object,
  toggleEdit: PropTypes.func,
  onSaveService: PropTypes.func,
  showEdit: PropTypes.bool,
};

export default ServiceDesc;
